import EssaisPlanifiesService from './services/essais.planifies.services';

const moduleName = 'app.massia.common.essais.planifies';

angular.module(moduleName, []).service('EssaisPlanifiesService', EssaisPlanifiesService);

export default moduleName;
